import React from "react";
import "./App.css";
import Login from "./components/pages/auth/login/Login";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AddRecord from "./components/pages/record/AddRecord";
import GroupDashboard from "./components/pages/dashboard/groupDashboard/GroupDashboard";
import Settings from "./components/pages/settings/Settings";
import GroupContextProvider from "./contexts/groupContext/Provider";
import Record from "./components/pages/record/Record";
import AppealReport from "./components/pages/reports/appealReport/AppealReport";
import AutoLogout from "./components/shared/autoLogout/AutoLogout";

const App = () => {
	AutoLogout();
	return (
		<GroupContextProvider>
			<div className="App">
				{/* <Login /> */}
				<BrowserRouter>
					<Routes>
						<Route path="/" element={<Login />} />
						<Route path="/idr/generate-report" element={<AppealReport />} />
						<Route path="/idr/dashboard" element={<GroupDashboard />} />
						<Route path="/idr/add-record" element={<Record />} />
						<Route path="/idr/settings" element={<Settings />} />
					</Routes>
					{/* <Dashboard /> */}
				</BrowserRouter>
			</div>
		</GroupContextProvider>
	);
};

export default App;
// Test
